<template>
  <AdminLayout>
    <Head title="Customers" />

    <template #pageTitle> Customers </template>

    <template #pageTitleWidgets>
      <DataGridControlBar />
    </template>

    <template #headingOptions>
      <button
        @click="openCreate()"
        type="button"
        class="inline-flex items-center px-4 py-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
      >
        <PlusSmIconSolid
          class="-ml-0.5 mr-2 h-5 w-5"
          aria-hidden="true"
        />
        Add Customer
      </button>
    </template>

    <DataGrid
      name="customers_data_table"
      :endpoint="route('api.tables.customers.index')"
      :filters="form"
      :columns="columns"
      :block-size="40"
      :page-size="40"
    />

    <template #modals>
      <CreateModal
        v-model:open="showingCreateModal"
        :medical-sources="medicalSources"
        :require-address="$page?.props?.auth?.company?.settings?.require_customer_address || false"
        @created="customerCreated"
      />
    </template>
  </AdminLayout>
</template>

<script setup>
import { useInitGridState } from '@/Components/DataGrid/Composables/grid-state'
import { ref } from 'vue'
const { context } = useInitGridState()

const showingCreateModal = ref(false)

const openCreate = () => {
  showingCreateModal.value = true
}

const customerCreated = () => {
  showingCreateModal.value = false
  context.refresh()
}
</script>

<script>
import { Head, Link } from '@inertiajs/vue3'
import { PlusSmIcon as PlusSmIconSolid } from '@heroicons/vue/solid'
import AdminLayout from '@/Layouts/AdminLayout.vue'
import DataTable from '@/Components/Table/DataTable'
import IndexRow from '@/Pages/Customers/Components/IndexRow'
import Pagination from '@/Components/Pagination.vue'
import CreateModal from '@/Pages/Customers/Components/CreateModal'
import formatters from '@/Mixins/formatters'
import isUrlAware from '@/Mixins/isUrlAware'
import DataGrid from '@/Components/DataGrid/Tables/Generic.vue'
import SimpleStatusCell from '@/Components/DataGrid/Cells/SimpleStatusCell.vue'
import LinkCell from '@/Components/DataGrid/Cells/LinkCell.vue'
import DateCell from '@/Components/DataGrid/Cells/DateCell.vue'
import DollarCell from '@/Components/DataGrid/Cells/DollarCell.vue'
import DataGridControlBar from '@/Components/DataGrid/Controls/ControlBar.vue'
import YesNoCell from '@/Components/DataGrid/Cells/YesNoCell.vue'
import capitalize from '@/Filters/Capitalize'

const trashedOptions = [
  { title: 'Active', current: true },
  { title: 'Archived', current: false }
]

export default {
  mixins: [formatters, isUrlAware],

  components: {
    AdminLayout,
    Head,
    Link,
    DataTable,
    IndexRow,
    Pagination,
    PlusSmIconSolid,
    CreateModal,
    DataGrid,
    SimpleStatusCell,
    LinkCell,
    DateCell,
    DollarCell,
    YesNoCell,
    DataGridControlBar
  },

  props: {
    /**
     * A list of simple integration objects that act as medical sources.
     * e.g. [ { id: 1, name: 'metrc' } ]
     */
    medicalSources: {
      type: Array,
      default() {
        return []
      }
    },
    regions: {
      type: Array,
      default() {
        return []
      }
    },
    customerStatuses: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {
      form: {},
      columns: [
        {
          headerName: 'Name',
          field: 'name',
          cellRenderer: 'LinkCell',
          cellRendererParams: (params) => ({
            url: `/customers/${params.data.id}`,
            display: params.value
          }),
          filter: 'agTextColumnFilter',
          flex: 1,
          minWidth: 200
        },
        {
          headerName: 'Status',
          field: 'status',
          cellRenderer: 'SimpleStatusCell',
          cellRendererParams: (params) => ({
            validStatuses: ['active'],
            invalidStatuses: ['disabled', 'banned']
          }),
          filter: 'agSetColumnFilter',
          filterParams: {
            values: this.customerStatuses
          }
        },
        {
          headerName: 'Phone',
          field: 'phone',
          filter: 'agTextColumnFilter'
        },
        {
          headerName: 'Last Region',
          field: 'last_order_region',
          // filter: 'agSetColumnFilter',
          // filterParams: {
          //     values: _.map(this.regions, (region) => region.name),
          // },
          suppressHeaderMenuButton: true,
          sortable: false
        },
        {
          headerName: 'Last Order Date',
          field: 'last_order_date',
          // filter: 'agDateColumnFilter',
          cellRenderer: 'DateCell',
          sortable: false
        },
        {
          headerName: 'Join Date',
          field: 'created_at',
          filter: 'agDateColumnFilter',
          sort: 'desc',
          cellRenderer: 'DateCell'
        },
        {
          headerName: 'LTV',
          field: 'orders_sum_total',
          cellRenderer: 'DollarCell'
        },
        {
          headerName: 'Valid Medical',
          field: 'has_valid_medical',
          cellRenderer: 'YesNoCell',
          sortable: false
        }
      ]
    }
  },

  methods: {
    editRow(item) {
      alert('EDIT ' + item.id)
    }
  }
}
</script>
